import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactUsOverlayComponent } from './contact-us-overlay.component';

@NgModule({
  imports: [CommonModule, ContactUsOverlayComponent],
  exports: [ContactUsOverlayComponent],
})
export class ContactUsOverlayModule {}
